module.exports = __webpack_public_path__ + "static/media/Google-Play.4eb8abaf.svg";